import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DetailRepository from "../Repositories/DetailRepository";

class DetailBloc {
  detailChannel = new Subject();
  listComponentChannel = new Subject();
  listCriteriaChannel = new Subject();
  fetchCriteria;
  createChannel = new Subject();
  repository = new DetailRepository();

  constructor() {
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.listComponentChannel.next({ status: apiResponse.INITIAL });
    this.listCriteriaChannel.next({ status: apiResponse.INITIAL });
    this.createChannel.next({ status: apiResponse.INITIAL });
  }

  fetchDetail = async (query) => {
    this.detailChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDetail(query)
      .then((result) => {
        this.detailChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.detailChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchComponent = async (query) => {
    this.listComponentChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchComponent(query)
      .then((result) => {
        this.listComponentChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.listComponentChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };

  fetchCriteria = async (query) => {
    this.listCriteriaChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchCriteria(query)
      .then((result) => {
        this.listCriteriaChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.listCriteriaChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default DetailBloc;
